import type { ModalSize } from '@/shared/ui/core/Modal';

export type EntityFormKind = 'compact' | 'standard' | 'lines';

export type EntityFormDismissIntent = 'close' | 'unsaved' | 'block';

/** Size convention for WEB create/edit modals (OI-029).
 * MX4: on phone (< lg), EntityFormModal auto-sheets sm|md|lg; xl/2xl stay centered (lines).
 */
export const ENTITY_FORM_MODAL_SIZE: Record<EntityFormKind, ModalSize> = {
  compact: 'md',
  standard: 'lg',
  lines: 'xl',
};

export function entityFormModalSizeFor(kind: EntityFormKind): ModalSize {
  return ENTITY_FORM_MODAL_SIZE[kind];
}

/**
 * Close request from X / Escape / overlay / Hủy.
 * Saving never discards. Dirty opens unsaved confirm instead of closing.
 */
export function resolveEntityFormDismiss(opts: {
  dirty: boolean;
  saving?: boolean;
}): EntityFormDismissIntent {
  if (opts.saving) return 'block';
  if (opts.dirty) return 'unsaved';
  return 'close';
}
